import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { IUpdateProductExclusionRulesPayload } from '../../interfaces';

export const requestUpdateProductRules = (lenderId: string, exclusionRules: IUpdateProductExclusionRulesPayload) => {
  const path = `/lender-service/lenders/${lenderId}/productTypeExclusionRule`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, exclusionRules);
      Notistack.successMessage('Product Rules - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateSubmitNakedDeal = (lenderId: string, submitNakedDeal: boolean) => {
  const path = `/lender-service/lenders/${lenderId}/submitNakedDeal?submitNakedDeal=${submitNakedDeal}`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path);
      Notistack.successMessage('Submit Naked Deal - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
